module.exports = __webpack_public_path__ + "static/media/illustration_large.54f5b137.png";